/**
 * The content site's tracker bundle: `/track.js`, built by apps/site/build.mjs.
 *
 * The apex domain is static HTML, so there is no request handler to record a
 * page view from — this is it. One page view per load, plus everything the
 * tracker sees. Cookie Domain is the registrable domain in production so the
 * consent choice and the visitor id are shared with the app.
 */

import { initTracker } from "./tracker.js";

const host = location.hostname;
const onSite = host === "xiangqimaster.com" || host.endsWith(".xiangqimaster.com");

initTracker({
  site: "site",
  ...(onSite ? { cookieDomain: ".xiangqimaster.com" } : {}),
  privacyUrl: "/privacy",
});
